// coordinate.duck.js

// ================ Action types ================ //
export const FETCH_COORDINATES_REQUEST = 'app/coordinates/FETCH_COORDINATES_REQUEST';
export const FETCH_COORDINATES_SUCCESS = 'app/coordinates/FETCH_COORDINATES_SUCCESS';
export const FETCH_COORDINATES_FAILURE = 'app/coordinates/FETCH_COORDINATES_FAILURE';

// ================ Reducer ================ //
const initialState = {
  loading: false,
  coordinates: null,
  error: null,
};

const coordinatesReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_COORDINATES_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_COORDINATES_SUCCESS:
      return { ...state, loading: false, coordinates: action.payload };
    case FETCH_COORDINATES_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

// ================ Action creators ================ //
export const fetchGeocoordinateRequest = () => ({ type: FETCH_COORDINATES_REQUEST });

export const fetchGeocoordinateSuccess = (coordinates) => ({
  type: FETCH_COORDINATES_SUCCESS,
  payload: coordinates,
});

export const fetchGeocoordinateFailure = (error) => ({
  type: FETCH_COORDINATES_FAILURE,
  payload: error,
});

// ================ Thunks ================ //
import axios from 'axios';

export const fetchCoordinates = (address) => async (dispatch, _getState, sdk) => {
  // Dispatch the loading state
  dispatch(fetchGeocoordinateRequest());

  const { street1, street2, city, state, postalCode, country } = address;
  const fullAddress = `${street1} ${street2 ? street2 + ', ' : ''}${city}, ${state}, ${country} ${postalCode}`;

  try {
    const response = await axios.get(
      `${process.env.REACT_APP_MAPBOX_GEOCODE_API_URL}/geocoding/v5/mapbox.places/${encodeURIComponent(fullAddress)}.json?access_token=${process.env.REACT_APP_MAPBOX_ACCESS_TOKEN}`
    );

    const [longitude, latitude] = response.data.features[0].center;

    // Dispatch success with coordinates
    dispatch(fetchGeocoordinateSuccess({ latitude, longitude }));
  } catch (error) {
    // Dispatch failure
    dispatch(fetchGeocoordinateFailure(error.message));
  }
};

export default coordinatesReducer;